import { MegaphoneIcon, MonitorIcon, PaletteIcon, RadioIcon } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export interface ServiceAreaItem {
  title: string
  desc: string
}

export interface ServiceArea {
  slug: string
  name: string
  tagline: string
  intro: string
  icon: LucideIcon
  items: ServiceAreaItem[]
}

export const SERVICE_AREAS: ServiceArea[] = [
  {
    slug: 'marketing-digital',
    name: 'Marketing Digital',
    tagline: 'Estrategia y contenido que hacen crecer tu marca',
    intro:
      'Planificamos, producimos y publicamos contenido con foco en resultados: más alcance, más comunidad y más consultas reales para tu negocio.',
    icon: MegaphoneIcon,
    items: [
      { title: 'Estrategia de contenidos', desc: 'Definimos ejes, tono y calendario de publicación para cada plataforma.' },
      { title: 'Gestión de redes sociales', desc: 'Producción, edición y publicación continua con seguimiento de métricas.' },
      { title: 'Campañas de pauta', desc: 'Segmentación, creatividades y optimización en Meta, Google y TikTok.' },
      { title: 'Contenido audiovisual para redes', desc: 'Reels, entrevistas y piezas cortas pensadas para consumo móvil.' },
    ],
  },
  {
    slug: 'tecnologia-led',
    name: 'Tecnología LED',
    tagline: 'Pantallas que transforman cualquier espacio',
    intro:
      'Proveemos, instalamos y operamos pantallas LED para eventos, comercios e instalaciones deportivas, con soporte técnico durante toda la experiencia.',
    icon: MonitorIcon,
    items: [
      { title: 'Alquiler de pantallas para eventos', desc: 'Estructuras indoor y outdoor con armado, operación y desmontaje.' },
      { title: 'Instalaciones fijas', desc: 'Proyecto, montaje y puesta en marcha de pantallas permanentes.' },
      { title: 'Operación técnica en vivo', desc: 'Control de contenido, señal y visuales durante el evento.' },
      { title: 'Contenido para pantallas', desc: 'Piezas y animaciones adaptadas al formato y resolución de cada LED.' },
    ],
  },
  {
    slug: 'identidad-de-marca',
    name: 'Identidad de Marca',
    tagline: 'Una identidad coherente en cada punto de contacto',
    intro:
      'Construimos sistemas visuales claros y aplicables, desde el logotipo hasta la señalética, para que la marca se reconozca en cualquier soporte.',
    icon: PaletteIcon,
    items: [
      { title: 'Identidad visual', desc: 'Logotipo, paleta, tipografías y criterios de uso.' },
      { title: 'Manual de marca', desc: 'Documento con reglas de aplicación para equipos internos y proveedores.' },
      { title: 'Gráfica y piezas comerciales', desc: 'Papelería, catálogos, packaging y material de venta.' },
      { title: 'Señalética y ambientación', desc: 'Señalización de espacios, stands y experiencias de marca.' },
    ],
  },
  {
    slug: 'streaming-broadcasting',
    name: 'Streaming & Broadcasting',
    tagline: 'Transmisiones profesionales en vivo',
    intro:
      'Cubrimos partidos, conferencias y lanzamientos con equipos multicámara, realización en vivo y salida simultánea a plataformas y canales.',
    icon: RadioIcon,
    items: [
      { title: 'Transmisión multicámara', desc: 'Realización en vivo con switcher, audio y monitoreo de señal.' },
      { title: 'Streaming deportivo', desc: 'Cobertura de ligas y clubes con marcador, replay y grafismo.' },
      { title: 'Eventos corporativos', desc: 'Conferencias híbridas, presentaciones y lanzamientos en vivo.' },
      { title: 'Distribución y grabación', desc: 'Emisión simultánea a plataformas y entrega del material grabado.' },
    ],
  },
]

export function getServiceArea(slug: string | undefined): ServiceArea | undefined {
  return SERVICE_AREAS.find((area) => area.slug === slug)
}
